export default "__VITE_ASSET__BTkONUfA__"